<template>
  <!-- <div> -->
    <mt-tabbar fixed class="flex flex-j-c-sa">
      <a @click="changeTab('tabCollege')">
        <mt-tab-item id="tabCollege">
            <img slot="icon" src="@/assets/comm/com_icon_go_s@3x.png" v-show="vals === 'tabCollege'">
            <img slot="icon" src="@/assets/comm/com_icon_go_n@3x.png" v-show="vals !== 'tabCollege'">
            <p :class="vals === 'tabCollege' ? 'text-black':''">{{vtext}}</p>
        </mt-tab-item>
      </a>
      <a @click="changeTab('tabRecruit')">
        <mt-tab-item id="tabRecruit">
            <img slot="icon" src="@/assets/comm/com_icon_student_s@3x.png" v-show="vals === 'tabRecruit'">
            <img slot="icon" src="@/assets/comm/com_icon_student_n@3x.png" v-show="vals !== 'tabRecruit'">
            <p :class="vals === 'tabRecruit' ? 'text-black':''">人人招生</p>
        </mt-tab-item>
      </a>
      <a @click="changeTab('tabMine')">
        <mt-tab-item id="tabMine">
            <img slot="icon" src="@/assets/comm/com_icon_my_s@3x.png" v-show="vals === 'tabMine'">
            <img slot="icon" src="@/assets/comm/com_icon_my_n@3x.png" v-show="vals !== 'tabMine'">
            <p :class="vals === 'tabMine' ? 'text-black':''">个人中心</p>
        </mt-tab-item>
      </a>
    </mt-tabbar>
    <!-- <iframe ref="iframe" :src="url" class="iframe" :style="tabH" frameborder="0" marginwidth="0" marginheight="0" scrolling="no"></iframe> -->
  <!-- </div> -->
</template>

<script>

export default {
  name: 'Footer',
  props: {
    vals: {
      type: String,
      default: 'tabCollege'
    },
    vtext: {
      type: String,
      default: '0元上大学'
    },
  },
  data() {
    return {
      sessionData: {},
      pageData: {},
      url:'http://live.zhenzhang.com/cgsys/poster/',
      tabH: '0px'
    }
  },
  // mounted() {
  //   let he = document.body.clientHeight;
  //   this.tabH = `height:${he - 55}px`;
  // },
  methods: {
    changeTab(e) {
      this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
      if (this.sessionData && this.sessionData.RecruitIndex) {
        this.pageData = JSON.parse(this.sessionData.RecruitIndex);
      }
      if (e !== this.vals){
        switch (e) {
          case 'tabCollege':
            let uid = JSON.parse(localStorage.getItem('cww_data')).id;
            if (this.pageData.level == 1) { // 已报名学生:推荐有礼
              window.location.href = `http://live.zhenzhang.com/cgsys/poster/`;
            } else if(this.pageData.level == 2) { // 助理合伙人：合伙人计划
              window.location.href = `http://live.zhenzhang.com/cgsys/partner/`;
            } else {
              window.location.href = `${window.location.origin}/home?id=${uid}`;
            }
            break;
          case 'tabRecruit':
            this.$router.push({name: 'RecruitIndex'})
            break;
          case 'tabMine':
            this.$router.push({name: 'Mine'})
            break;
          default:
            break;
        }
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.mint-tabbar.is-fixed{
    left: 50%;
    max-width: 640px;
    width: 100%;
    transform: translateX(-50%);
}
    .mint-tabbar{
        background-color: white;
        // border-top:0.5px solid #EEEEEE;
        color: #dbdbdb;
        &>.mint-tab-item.is-selected{
            // border-top: 0.1px solid #EEEEEE;
            background-color: white;
            color: black;
        }
    }
.iframe{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
